import http from '@services/http';
import { Health } from '@services/api/interfaces';

export const getBuild = (): Promise<Health.GetBuild.Response> => {
  return http.get(`/health/build`);
};